import type { FC, SVGProps } from 'react';

export const TwilioLogo: FC<SVGProps<SVGSVGElement>> = ({
  width = 28,
  height = 28,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="10" fill="#F22F46" />
    <circle cx="8.5" cy="8.5" r="2" fill="white" />
    <circle cx="15.5" cy="8.5" r="2" fill="white" />
    <circle cx="8.5" cy="15.5" r="2" fill="white" />
    <circle cx="15.5" cy="15.5" r="2" fill="white" />
  </svg>
);
